theme.headerSection = (function () {
  function header() {
    
    /* Hulpfuncties voor animaties (Slide Up / Slide Down) */
    /* Dit zorgt ervoor dat het menu werkt, zelfs als theme-functies ontbreken */
    const slideUp = (target, duration = 300) => {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight; 
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }

    const slideDown = (target, duration = 300) => {
      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;
      if (display === 'none') display = 'block';
      target.style.display = display;
      let height = target.offsetHeight;
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight; 
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        target.style.height = null;
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }

    /* Mobile Menu Function */
    const MobileMenu = function () {
      const offcanvasOpen = document.querySelector(".header__actions_btn--menu"),
            offcanvasClose = document.querySelector(".offcanvas__close_btn"),
            offcanvasHeader = document.querySelector(".offcanvas-header"),
            body = document.querySelector("body");

      /* 1. Open/Sluit het volledige mobiele menu */
      if (offcanvasOpen) {
        offcanvasOpen.addEventListener("click", function (e) {
          e.preventDefault();
          if (offcanvasHeader) offcanvasHeader.classList.add("open");
          if (body) body.style.overflowY = "hidden";
        });
      }
      if (offcanvasClose) {
        offcanvasClose.addEventListener("click", function (e) {
          e.preventDefault();
          if (offcanvasHeader) offcanvasHeader.classList.remove("open");
          if (body) body.style.overflowY = null;
        });
      }

      /* 2. De Submenu Logica (De Fix) */
      if (offcanvasHeader) {
        // We zoeken ALLE submenus in de header, ongeacht waar ze verstopt zitten
        const allSubMenus = offcanvasHeader.querySelectorAll(".offcanvas__sub_menu");

        allSubMenus.forEach(function (ul) {
          // Zoek de parent (LI)
          const parentLi = ul.closest("li");
          if (!parentLi) return;

          // Check of er al een knop is, zo niet, maak hem aan
          let toggleBtn = parentLi.querySelector(".offcanvas__sub_menu_toggle");
          if (!toggleBtn) {
            toggleBtn = document.createElement("button");
            toggleBtn.classList.add("offcanvas__sub_menu_toggle");
            toggleBtn.setAttribute("aria-label", "menu collapse");
            // Voeg knop toe aan de LI (meestal naast de link of UL)
            parentLi.appendChild(toggleBtn);
          }

          // Zoek de tekst link
          const textLink = parentLi.querySelector("a");

          // DE CENTRALE FUNCTIE: Wat gebeurt er als je klikt?
          const handleToggle = function(e) {
            e.preventDefault(); // Voorkom dat de link navigeert

            const isItemOpen = parentLi.classList.contains("active");

            if (isItemOpen) {
              // --- SLUITEN ---
              parentLi.classList.remove("active");
              toggleBtn.classList.remove("active");
              slideUp(ul);

              // Sluit ook eventuele dieperliggende open items
              ul.querySelectorAll(".offcanvas__sub_menu").forEach(subUl => {
                subUl.closest("li").classList.remove("active");
                slideUp(subUl);
                const subBtn = subUl.closest("li").querySelector(".offcanvas__sub_menu_toggle");
                if(subBtn) subBtn.classList.remove("active");
              });

            } else {
              // --- OPENEN ---
              parentLi.classList.add("active");
              toggleBtn.classList.add("active");
              slideDown(ul);

              // Sluit de 'buren' (siblings) die open staan
              const siblings = Array.from(parentLi.parentNode.children).filter(child => child !== parentLi);
              siblings.forEach(sibling => {
                if (sibling.classList.contains("active")) {
                  sibling.classList.remove("active");
                  const sibBtn = sibling.querySelector(".offcanvas__sub_menu_toggle");
                  if (sibBtn) sibBtn.classList.remove("active");
                  
                  // Zoek de submenu in deze sibling en sluit hem
                  const sibUl = sibling.querySelector(".offcanvas__sub_menu");
                  if (sibUl) slideUp(sibUl);
                }
              });
            }
          };

          // Koppel de functie aan de KNOP
          toggleBtn.onclick = handleToggle;

          // Koppel de functie aan de TEKST (indien aanwezig)
          if (textLink) {
            // We gebruiken onclick om zeker te zijn dat we oude events overschrijven
            textLink.onclick = handleToggle;
          }
        });
      }

      /* Sluit menu bij klik buiten het menu */
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".header__actions_btn--menu") && 
            !event.target.closest(".offcanvas-header")) {
           if(offcanvasHeader && offcanvasHeader.classList.contains("open")) {
              offcanvasHeader.classList.remove("open");
              body.style.overflowY = null;
           }
        }
      });

      /* Resize event */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          if(offcanvasHeader) offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    
    /* Start de functie */
    MobileMenu();

    /* Tab Switch Logica (Menu / Categorieën tabs bovenin) */
    const mobileMenuToggleButtons = document.querySelectorAll(".mobile--menu-header-button");
    const mobileMainMenu = document.querySelector(".mobile__main-menu--list");
    const mobileVerticalMenu = document.querySelector(".mobile__categories--list");
    
    if (mobileMenuToggleButtons.length > 0) {
      mobileMenuToggleButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          // Reset actieve class op knoppen
          mobileMenuToggleButtons.forEach((childButton) => {
            childButton.classList.remove("active");
          });
          button.classList.add("active");
          
          // Wissel tussen Menu en Categorieën
          if (button.classList.contains("mobile__main--menu")) {
            if (mobileMainMenu) mobileMainMenu.classList.remove("d-none");
            if (mobileVerticalMenu) mobileVerticalMenu.classList.add("d-none");
          }
          if (button.classList.contains("mobile__categories--menu")) {
            if (mobileVerticalMenu) mobileVerticalMenu.classList.remove("d-none");
            if (mobileMainMenu) mobileMainMenu.classList.add("d-none");
          }
        });
      });
    }
  }

  return header;
})();